<template>
  <div
    name="xpage-search-filters"
    class="search-page-search-filters"
    @click.self="searchPageStore.searchPageState.filterDisplay = false"
    :class="{ visible: searchPageStore.searchPageState.filterDisplay }"
  >
    <div class="search-page-search-filter" name="xpage-search-filter">
      <div
        class="search-page-search-filters-close icon-x"
        @click="searchPageStore.searchPageState.filterDisplay = false"
      >
      </div>
      <h3>Filter Categories</h3>
      <div
        name="xpage-search-filter-scroll"
        class="search-page-search-filter-scroll"
      >
        <div
          name="xpage-search-filter-section xpage-search-filter-scroll"
          class="search-page-search-filter-section"
          v-for="(section, index) in filterDefinitions"
          :key="index"
        >
          <div class="section-description-wrapper">
            <h3>
              {{ section?.label }}
            </h3>
            <span
              class="section-description-icon"
              @click="toggleFilterSection(section)"
            >
              <font-awesome-icon class="" :icon="toggleIcon(section)"
            /></span>
          </div>
          <div class="section-filters" v-show="!section.collapsed">
            <SearchPageFilterOptions :filterDefinition="section" />
          </div>
        </div>
      </div>
    </div>
    <div class="xpage-search-filter-modal">
      <SearchPageFiltersModal
        v-if="searchPageStore.searchPageState.filterModal.active"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { SearchPageProperties, FilterDefinition } from "@/types/search-page";
import { PropType, ref, watch } from "vue";
import SearchPageFilterOptions from "@/components/v2/search-page/SearchPageFilterOptions.vue";
import { useSearchPageStore } from "@/store/store/searchPageStore";
import SearchPageFiltersModal from "@/components/v2/search-page/SearchPageFiltersModal.vue";

const searchPageStore = useSearchPageStore();

const props = defineProps({
  settings: {
    type: Object as PropType<SearchPageProperties>,
  },
  filterDefinitions: {
    type: Array as PropType<Array<FilterDefinition>>,
    required: true,
  },
});

let localData = ref<SearchPageProperties>(
  JSON.parse(JSON.stringify(props.settings))
);

const toggleIcon = (filterDefinition: FilterDefinition) => {
  if (filterDefinition) {
    return filterDefinition.collapsed
      ? "fa-solid fa-chevron-down"
      : "fa-solid fa-chevron-up";
  }

  return "fa-solid fa-chevron-down";
};

function toggleFilterSection(section: FilterDefinition) {
  const action = section.collapsed ? "expand" : "collapse";
  searchPageStore.toggleFilterSection(action, section);
}

watch(
  () => searchPageStore.searchPageState.query,
  (newQuery) => {
    localData.value.query.totalCount = newQuery.totalCount;
  },
  { deep: true }
);
</script>
<style scoped src="@/assets/css/search-page/search-page.css"></style>
<style scoped src="@/assets/css/search-page/search-page-filters.css"></style>
